var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-list"},_vm._l((_vm.navList),function(item,i){return _c('div',{key:i,staticClass:"item",on:{"click":function($event){return _vm.toPage(item.path)}}},[_c('img',{attrs:{"src":require('../../assets/mobile/icon/' + item.icon),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.lang === 'zh' ? item.title : item.enTitle))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }